/**
 * Transforms a ancillary booking part fulfillments into a refundable for ancillaries.
 */
export function transformRefundableAncillary(
    ancillary: ApiSchema['Ancillary'],
    apiBooking: ApiSchema['Booking'],
): RefundableAncillary {
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === ancillary.id));
    const id = ancillary.id;
    const fulfillmentId = fulfillment?.id;
    const type = 'Ancillary';
    const ancillaryType = ancillary.type;
    const summaryLine1 = ancillary.summary ?? '';
    const summaryLine2 = '';
    const detailLine1 = '';
    const detailLine2 = '';
    const status = ancillary.status;
    const price = ancillary.price;
    const refundDeadline = undefined;
    const isExpired = false;
    const isRefunded = false;
    const isRefundable = false;

    return {
        id,
        fulfillmentId,
        type,
        ancillaryType,
        summaryLine1,
        summaryLine2,
        detailLine1,
        detailLine2,
        status,
        price,
        refundDeadline,
        isExpired,
        isRefunded,
        isRefundable,
    };
}
